// Mock Data Service for Messaging System
// Following existing patterns from Dashboard mockDataService

import { 
  Conversation, 
  Message, 
  User, 
  Attachment,
  MessageMetadata,
  MessageReaction,
  Notification
} from '../../types/messaging';

// Mock Notifications
export const mockNotifications: Notification[] = [
  {
    id: 'notif-1',
    userId: 'user-1',
    type: 'like',
    title: 'New Like!',
    content: 'Jessica liked your profile.',
    isRead: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 30) // 30 mins ago
  },
  {
    id: 'notif-2',
    userId: 'user-1',
    type: 'match',
    title: 'It\'s a Match!',
    content: 'You matched with Michael! Start a conversation now.',
    relatedId: 'conv-2',
    isRead: true,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 2) // 2 hours ago
  },
  {
    id: 'notif-3',
    userId: 'user-1',
    type: 'system',
    title: 'Welcome to Plenty of Hearts',
    content: 'Thanks for joining! Complete your profile to get more matches.',
    isRead: true,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2) // 2 days ago
  },
  {
    id: 'notif-4',
    userId: 'user-1',
    type: 'bet',
    title: 'New Bet Offer',
    content: 'Sophia wants to bet a dinner date!',
    relatedId: 'bet-conv-1',
    isRead: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 5)
  }
];

// Mock Users
export const mockUsers: User[] = [
  {
    id: "user-1",
    name: "John Doe",
    email: "john@example.com",
    avatar: "https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80",
    isOnline: true,
    lastSeen: new Date()
  },
  {
    id: "user-2", 
    name: "Jessica Miller",
    email: "jessica@example.com",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80",
    isOnline: false,
    lastSeen: new Date(Date.now() - 1000 * 60 * 30) // 30 minutes ago
  },
  {
    id: "user-3",
    name: "Michael Chen",
    email: "mike@example.com", 
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80",
    isOnline: true,
    lastSeen: new Date()
  },
  {
    id: "user-4",
    name: "Sarah Wilson",
    email: "sarah@example.com",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80", 
    isOnline: false,
    lastSeen: new Date(Date.now() - 1000 * 60 * 60 * 2) // 2 hours ago
  },
  {
    id: "user-5",
    name: "David Brown",
    email: "david@example.com",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80",
    isOnline: true,
    lastSeen: new Date()
  }
];

// Mock Messages
export const mockMessages: Message[] = [
  {
    id: "msg-1",
    conversationId: "conv-1",
    senderId: "user-2",
    recipientId: "user-1",
    content: "Hey! How are you doing?",
    messageType: "text",
    isRead: false,
    isDelivered: true,
    isEdited: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 5), // 5 minutes ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 5)
  },
  {
    id: "msg-2",
    conversationId: "conv-1", 
    senderId: "user-1",
    recipientId: "user-2",
    content: "I'm doing great! Thanks for asking. How about you?",
    messageType: "text",
    isRead: true,
    isDelivered: true,
    isEdited: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 3), // 3 minutes ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 3)
  },
  {
    id: "msg-3",
    conversationId: "conv-1",
    senderId: "user-2", 
    recipientId: "user-1",
    content: "I'm wonderful! Just finished a great workout. What are your plans for the weekend?",
    messageType: "text",
    isRead: false,
    isDelivered: true,
    isEdited: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 1), // 1 minute ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 1)
  },
  {
    id: "msg-4",
    conversationId: "conv-2",
    senderId: "user-3",
    recipientId: "user-1", 
    content: "Hey! I saw your profile and thought we might have a lot in common. Love your hiking photos!",
    messageType: "text",
    isRead: true,
    isDelivered: true,
    isEdited: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 2), // 2 hours ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 2)
  },
  {
    id: "msg-5",
    conversationId: "conv-2",
    senderId: "user-1",
    recipientId: "user-3",
    content: "Thank you! I love hiking too. Have you been to the mountains recently?",
    messageType: "text", 
    isRead: true,
    isDelivered: true,
    isEdited: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 1), // 1 hour ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 1)
  },
  {
    id: "msg-6",
    conversationId: "conv-3",
    senderId: "user-4",
    recipientId: "user-1",
    content: "Hi there! Your bio made me laugh. Coffee enthusiast and dog lover - we'd get along great!",
    messageType: "text",
    isRead: false,
    isDelivered: true,
    isEdited: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 6), // 6 hours ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 6)
  },
  {
    id: "msg-7",
    conversationId: "conv-4",
    senderId: "user-5",
    recipientId: "user-1",
    content: "Hello! I noticed we're both into photography. Do you have any favorite spots to shoot?",
    messageType: "text",
    isRead: true,
    isDelivered: true,
    isEdited: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 12), // 12 hours ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 12)
  },
  {
    id: "msg-8",
    conversationId: "conv-4",
    senderId: "user-1",
    recipientId: "user-5",
    content: "Yes! I love shooting at sunrise by the lake. The light is absolutely magical.",
    messageType: "text",
    isRead: true,
    isDelivered: true,
    isEdited: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 10), // 10 hours ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 10)
  },
  {
    id: "msg-9",
    conversationId: "conv-1",
    senderId: "user-2",
    recipientId: "user-1",
    content: "Check out this photo from my hike!",
    messageType: "image",
    attachments: [{
      id: "att-1",
      type: "image",
      url: "/placeholder.jpg",
      filename: "hike-photo.jpg",
      size: 2048576, // 2MB
      mimeType: "image/jpeg"
    }],
    isRead: false,
    isDelivered: true,
    isEdited: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 30), // 30 minutes ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 30)
  },
  {
    id: "msg-10",
    conversationId: "conv-1",
    senderId: "user-1",
    recipientId: "user-2",
    content: "Here's that document you requested",
    messageType: "file",
    attachments: [{
      id: "att-2",
      type: "file",
      url: "/placeholder.pdf",
      filename: "project-proposal.pdf",
      size: 1048576, // 1MB
      mimeType: "application/pdf"
    }],
    isRead: true,
    isDelivered: true,
    isEdited: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 15), // 15 minutes ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 15)
  },
  {
    id: "msg-11",
    conversationId: "conv-1",
    senderId: "user-2",
    recipientId: "user-1",
    content: "Listen to this song I recorded!",
    messageType: "audio",
    attachments: [{
      id: "att-3",
      type: "audio",
      url: "/placeholder-audio.mp3",
      filename: "my-song.mp3",
      size: 5242880, // 5MB
      mimeType: "audio/mpeg"
    }],
    isRead: false,
    isDelivered: true,
    isEdited: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 10), // 10 minutes ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 10)
  }
];

// Mock Bet Conversations (from swipe deck)
// Mock Bet Conversations (from swipe deck)
const mockBetUsers: User[] = [
  {
    id: "bet-user-1",
    name: "Sophia Martinez",
    email: "sarah.m@example.com",
    avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80",
    isOnline: false,
    lastSeen: new Date(Date.now() - 1000 * 60 * 60 * 2) // 2 hours ago
  },
  {
    id: "bet-user-2",
    name: "Emma Thompson",
    email: "emma.t@example.com",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80",
    isOnline: true,
    lastSeen: new Date()
  },
  {
    id: "bet-user-3",
    name: "Olivia Chen",
    email: "olivia.c@example.com",
    avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80",
    isOnline: false,
    lastSeen: new Date(Date.now() - 1000 * 60 * 30) // 30 minutes ago
  }
];

// Mock Conversations
export const mockConversations: Conversation[] = [
  // Regular conversations (for All tab - but these won't show in Unread for non-premium)
  {
    id: "conv-1",
    participants: [mockUsers[0], mockUsers[1]], // John Doe, Jane Smith
    lastMessage: mockMessages[10], // Latest audio message from Jane
    unreadCount: 0, // Changed to 0 so it doesn't show in Unread for non-premium
    isMuted: false,
    isBlocked: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24), // 1 day ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 10) // 10 minutes ago
  },
  {
    id: "conv-2", 
    participants: [mockUsers[0], mockUsers[2]], // John Doe, Mike Johnson
    lastMessage: mockMessages[4], // Latest message from John
    unreadCount: 0,
    isMuted: false,
    isBlocked: false,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 48), // 2 days ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 1) // 1 hour ago
  },
  // Bet conversations (from swipe deck)
  {
    id: "bet-conv-1",
    participants: [mockUsers[0], mockBetUsers[0]], // John Doe, Sarah Martinez
    lastMessage: {
      id: "bet-msg-1",
      conversationId: "bet-conv-1",
      senderId: mockBetUsers[0].id,
      recipientId: mockUsers[0].id,
      content: "Hey! I'd love to take you out for dinner. You seem really interesting!",
      messageType: "text",
      isRead: false,
      isDelivered: true,
      isEdited: false,
      createdAt: new Date(Date.now() - 1000 * 60 * 60 * 6), // 6 hours ago
      updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 6)
    },
    unreadCount: 1,
    isMuted: false,
    isBlocked: false,
    isBet: true,
    betLevel: 'medium',
    betMessage: "Hey! I'd love to take you out for dinner. You seem really interesting!",
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 6), // 6 hours ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 6)
  },
  {
    id: "bet-conv-2",
    participants: [mockUsers[0], mockBetUsers[1]], // John Doe, Emma Thompson
    lastMessage: {
      id: "bet-msg-2",
      conversationId: "bet-conv-2",
      senderId: mockBetUsers[1].id,
      recipientId: mockUsers[0].id,
      content: "Coffee sounds perfect! When are you free?",
      messageType: "text",
      isRead: false,
      isDelivered: true,
      isEdited: false,
      createdAt: new Date(Date.now() - 1000 * 60 * 60 * 12), // 12 hours ago
      updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 12)
    },
    unreadCount: 1,
    isMuted: false,
    isBlocked: false,
    isBet: true,
    betLevel: 'low',
    betMessage: "Coffee sounds perfect! When are you free?",
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 12), // 12 hours ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 12)
  },
  {
    id: "bet-conv-3",
    participants: [mockUsers[0], mockBetUsers[2]], // John Doe, Olivia Chen
    lastMessage: {
      id: "bet-msg-3",
      conversationId: "bet-conv-3",
      senderId: mockBetUsers[2].id,
      recipientId: mockUsers[0].id,
      content: "I'd love to explore that new art gallery with you!",
      messageType: "text",
      isRead: true,
      isDelivered: true,
      isEdited: false,
      createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24), // 1 day ago
      updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 24)
    },
    unreadCount: 0,
    isMuted: false,
    isBlocked: false,
    isBet: true,
    betLevel: 'high',
    betMessage: "I'd love to explore that new art gallery with you!",
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24), // 1 day ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 24)
  }
];

// Mock Attachments
export const mockAttachments: Attachment[] = [
  {
    id: "att-1",
    type: "image",
    url: "/placeholder.jpg",
    filename: "sunset-photo.jpg",
    size: 1024000, // 1MB
    mimeType: "image/jpeg"
  },
  {
    id: "att-2", 
    type: "video",
    url: "/placeholder-video.mp4",
    filename: "hiking-video.mp4",
    size: 5120000, // 5MB
    mimeType: "video/mp4"
  },
  {
    id: "att-3",
    type: "file",
    url: "/placeholder-document.pdf",
    filename: "travel-guide.pdf", 
    size: 2048000, // 2MB
    mimeType: "application/pdf"
  }
];

// Mock Message Reactions
export const mockReactions: MessageReaction[] = [
  {
    userId: "user-2",
    emoji: "❤️",
    createdAt: new Date(Date.now() - 1000 * 60 * 10)
  },
  {
    userId: "user-3",
    emoji: "👍",
    createdAt: new Date(Date.now() - 1000 * 60 * 5)
  },
  {
    userId: "user-4",
    emoji: "😂",
    createdAt: new Date(Date.now() - 1000 * 60 * 2)
  }
];

// Helper functions
export const getConversationById = (id: string): Conversation | undefined => {
  return mockConversations.find(conv => conv.id === id);
};

export const getMessagesByConversationId = (conversationId: string): Message[] => {
  return mockMessages.filter(msg => msg.conversationId === conversationId);
};

export const getUserById = (id: string): User | undefined => {
  return mockUsers.find(user => user.id === id);
};

export const getConversationsByUserId = (userId: string): Conversation[] => {
  return mockConversations.filter(conv => 
    conv.participants.some((participant: User) => participant.id === userId)
  );
};

export const getUnreadMessageCount = (userId: string): number => {
  const userConversations = getConversationsByUserId(userId);
  return userConversations.reduce((total, conv) => total + conv.unreadCount, 0);
};

export const getRecentMessages = (userId: string, limit: number = 5): Message[] => {
  const userConversations = getConversationsByUserId(userId);
  const allMessages = userConversations
    .map(conv => getMessagesByConversationId(conv.id))
    .flat()
    .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());
  
  return allMessages.slice(0, limit);
};

// Mock data generation functions
export const generateMockMessage = (
  conversationId: string,
  senderId: string,
  recipientId: string,
  content: string,
  messageType: "text" | "image" | "video" | "audio" | "file" = "text"
): Message => {
  const now = new Date();
  return {
    id: `msg-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    conversationId,
    senderId,
    recipientId,
    content,
    messageType,
    isRead: false,
    isDelivered: true,
    isEdited: false,
    createdAt: now,
    updatedAt: now
  };
};

export const generateMockConversation = (
  participants: User[],
  lastMessage?: Message
): Conversation => {
  const now = new Date();
  return {
    id: `conv-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    participants,
    lastMessage,
    unreadCount: 0,
    isMuted: false,
    isBlocked: false,
    createdAt: now,
    updatedAt: now
  };
};
